import {
	Card,
	CardBody,
	CardHeader,
} from "@tql/ui-components-react/kendo/layout";

import type { ShipmentManagementPickupDeliveryDetails } from "~/shared/schemas/shipment-management-schema.ts";

import { ShipmentDetail } from "../shipment-detail/shipment-detail.tsx";

export const ShipmentLocationCard = ({
	customerId,
	details,
	name,
}: {
	customerId: number;
	details?: ShipmentManagementPickupDeliveryDetails;
	name: "pickup" | "delivery";
}) => (
	<div className={"half-size-card"}>
		<Card className={"full-height"}>
			<CardHeader>
				<h3>{name === "pickup" ? "Pickup" : "Delivery"}</h3>
			</CardHeader>
			<CardBody>
				<ShipmentDetail customerId={customerId} details={details} name={name} />
			</CardBody>
		</Card>
	</div>
);
